export function officesMap() {
    const _window = this._window;
    const _document = this._document;
    const officesWrap = _document.querySelector(".search-offices");
    const search = officesWrap.querySelector(".search-field");
    const searchInput = search.querySelector("input[type=\"search\"]");
    let markers = [];
    
    
    _window.addEventListener("load", () => {
        const width = _window.innerWidth;
        const zoom = (width < 1600 && width > 1200) ? 2 : (width < 1200 && width > 640) ? 1.7 : (width < 640 ) ? 1 : 2.7;

        const normalIcon = {
            path: "M11.8,35c5-6,11.6-16.1,11.6-23.3C23.4,5.3,18.1,0,11.7,0C5.3,0,0,5.3,0,11.7C0,19.1,6.5,28.8,11.8,35z M11.7,17.2c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c3,0,5.5,2.5,5.5,5.5C17.2,14.7,14.7,17.2,11.7,17.2z",
            fillColor: "#0A2756",
            fillOpacity: 1,
            anchor: new google.maps.Point(13, 37),
            size: new google.maps.Size(26,37),
            strokeColor: "#FFFFFF",
            strokeOpacity: 0.5,
            strokeWeight: 1,
        };

        const hoverIcon = {
            path: "M11.8,35c5-6,11.6-16.1,11.6-23.3C23.4,5.3,18.1,0,11.7,0C5.3,0,0,5.3,0,11.7C0,19.1,6.5,28.8,11.8,35z M11.7,17.2c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5c3,0,5.5,2.5,5.5,5.5C17.2,14.7,14.7,17.2,11.7,17.2z",
            fillColor: "#00B5B1",
            fillOpacity: 1,
            anchor: new google.maps.Point(13, 37),
            size: new google.maps.Size(26,37),
            strokeColor: "#FFFFFF",
            strokeOpacity: 0.5,
            strokeWeight: 1
        };

        let infoWindow = null;

        const map = new google.maps.Map(
            _document.getElementById("offices-map"),
            {
                zoom,
                center: {lat: 15, lng: 25},
                disableDefaultUI: true,
                styles: [
                    {
                        "featureType": "administrative",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#ffffff"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "labels.text",
                        "stylers": [
                            {
                                "weight": "0.90"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#224442"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": "#a6e5e4"
                            },
                            {
                                "visibility": "on"
                            },
                            {
                                "saturation": "0"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape.man_made",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "all",
                        "stylers": [
                            {
                                "saturation": -100
                            },
                            {
                                "lightness": 45
                            },
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#ffffff"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#ffffff"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#ffffff"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#ffffff"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "visibility": "on"
                            }
                        ]
                    }
                ]
            }
        );

        const contentString = ({city, address, getDirections, phone, email, careerOpportunities, directionsLinkText, careerOpportunitiesText, }) => (
            `<div>
                ${city ? "<h3>" + city + "</h3>" : ""}
                ${address ? "<address>" + address + "</address>" : ""}
                ${getDirections ? "<p><a class=\"button\" href=\"" + getDirections + "\" target=\"_blank\">" + directionsLinkText + "</a></p>" : ""}
                ${phone ? "<p><a href=\"tel:" + phone+ "\">" + phone + "</a></p>" : ""}
                ${email ? "<strong>Email</strong><p><a href=\"mailto:" + email+ "\">" + email + "</a></p>" : ""}
                ${careerOpportunities ? "<p><a class=\"button\" href=\"" + careerOpportunities + "\" target=\"_blank\"> " + careerOpportunitiesText + "</a></p>" : ""}
            </div>`
        );

        for(const office of offices) {
            var marker = new google.maps.Marker({
                position: {lat: office.lat, lng: office.lng},
                icon: normalIcon,
                map: map
            });

            markers.push(marker);

            marker.addListener("click", function () {
                if(infoWindow) {
                    infoWindow.close();
                }

                setTimeout(() => {
                    infoWindow = new google.maps.InfoWindow({
                        content: contentString(office)
                    });
        
                    infoWindow.open(map, this);
                }, 100);
            });

            marker.addListener("mouseover", function () {
                this.setIcon(hoverIcon);
            });
            marker.addListener("mouseout", function (event) {
                this.setIcon(normalIcon);
            });
        }

        search.addEventListener("submit", (event) => {
            event.preventDefault();
            const query = searchInput.value.replace(",", "").toLowerCase();
            hideError();
            
            if(query.length > 2) {
                let errorFlag = true;
                let stopSearch = false;
                offices.forEach((office, index) => {
                    const officeString = Object.values(office).join(" ").replace(",", "").toLowerCase();
                    if(officeString.includes(query) && !stopSearch) {
                        google.maps.event.trigger(markers[index], "click");
                        stopSearch = true;
                        hideError();
                    } else {
                        if(errorFlag && !stopSearch) {
                            errorFlag = false;
                            showError();
                        }
                    }
                });
            } else {
                closeInfoWindow();
                showError();
            }
        });

        search.addEventListener("keydown", () => {
            if(!searchInput.value.length) {
                closeInfoWindow();
                hideError();
                searchInput.addEventListener("blur", () => {
                    hideError();
                });
            }
        });

        function showError() {
            search.classList.add("error");
            if(infoWindow) {
                infoWindow.close();
            }
        };

        function hideError() {
            search.classList.remove("error");
        };

        function closeInfoWindow() {
            if(infoWindow) {
                infoWindow.close();
            }
        };
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/offices-map.js